import {  reactive  } from 'vue'
export const stateSymbol = Symbol('state')
export const createState = reactive({
    
  
    brokerip:'live.bowling.suooter.com',
    // brokerip:'127.0.0.1',
    // brokerip:'192.168.24.204',
    projectTopic:'',//具体项目topic
    topicType:false,//控制是否进行跳转 ranking页面选择其他阶段时使用
    matchTopic: "NSSP0001/CompetitionListFlat",
    pdfListTopic:"bowling/pdfList", //发送PDF的文件list
    matchList:[],//所有线上比赛信息
    selectedMatchId:'',//比赛id
    matchInfo: {},//比赛信息
    projectInfo:{},//项目信息
    menuList:[],//比赛列表
    groupList:[],//组别列表
    projectList:[],//项目列表
    client: {},
    mqttData: {}, //对阵表所有数据
    svgComponentName:'',//svgname 用于展示靶面
    showList:[],//成绩展示list
    propshowData:[],//ranking页面侧滑项目list
    show:false,//侧滑开关
    active:0,//组别切换
    ProActive: 0,//项目切换
    showProject:"",//项目名
    pdfmatchList: [],//pdf比赛列表
    pdfprojectList:[],//pdf项目列表
    showYear: [],//默认展示年份
    championship:0, //比赛类型，判断是巡回赛还是锦标赛，0不展示组别，1展示组别
})